$(function () {
    $('.delete-permission-btn').on('click', function () {
        var $button      = $(this);
        var $modal       = $('#delete-permission-modal');
        var permissionId = $button.data('id');
        var userFullName = $button.data('user-full-name');

        $modal.find('input[name="id"]').val(permissionId).trigger('change');
        $modal.find('.permitted-user-name-text').text(userFullName);
    });

    $('#new-permission-modal').on('hidden.bs.modal', function () {
        $('#user-id').val('').trigger('change');
    });
});
